import { WHY } from "@/data/site";
import { SectionHead, Reveal } from "@/components/common/Reveal";
import { CtaLink } from "@/components/common/Buttons";

export const WhyQuantivo = ({ index = "04" }) => (
  <section className="relative bg-[#030712] py-24 text-white lg:py-32" data-testid="why-section">
    <div className="container-q grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <SectionHead dark index={index} label="Why Quantivo" title="Built for the long run, not just the launch."
            text="We work as an engineering partner: clear about scope, careful with architecture, and available after go-live." />
          <Reveal delay={0.2} className="mt-10"><CtaLink to="/about" variant="ghostDark" arrow="right" data-testid="why-about-link">How we work</CtaLink></Reveal>
        </div>
      </div>
      <ol className="border-t border-white/10 lg:col-span-7">
        {WHY.map((w, i) => (
          <Reveal as="li" key={w.title} delay={i * 0.04} className="group relative grid gap-3 border-b border-white/10 py-8 pl-0 transition-[padding] duration-300 hover:pl-4 sm:grid-cols-[64px_1fr]" data-testid={`why-item-${i}`}>
            <span className="grad-line absolute left-0 top-8 h-[calc(100%-4rem)] w-[2px] origin-top scale-y-0 transition-transform duration-300 group-hover:scale-y-100" />
            <span className="font-mono text-[13px] text-cyan-300">/0{i + 1}</span>
            <div>
              <h3 className="text-lg font-bold tracking-tight text-white sm:text-xl">{w.title}</h3>
              <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-400">{w.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
